import { FC } from 'react';

import { SkeletonAnimation } from '@base-app';
import { LoaderProps } from './Loader.types';
import { StyledRectangleShape } from './Loader.styles';

const Loader: FC<LoaderProps> = ({ css }) => {
  return (
    <SkeletonAnimation data-testid="loader" height={'100%'} width={'100%'} style={css}>
      <StyledRectangleShape />
    </SkeletonAnimation>
  );
};

export default Loader;
